import Nav from './components/Nav';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Transformation from './components/Transformation';
import Process from './components/Process';
import Proof from './components/Proof';
import AboutMe from './components/AboutMe';
import Finale from './components/Finale';
import Footer from './components/Footer';
import StructuredData from './components/StructuredData';
import Showcase from './components/Showcase';

/**
 * App shell. Skip-link must be the first focusable element so
 * keyboard/screen-reader users can bypass the fixed nav. Every section
 * below is a direct child of <main>; anchor nav targets live on those
 * sections, not on wrapper divs.
 *
 * Section order is intentional. The new Hero is the brand-guide-style
 * "Website Header Example" — pure positioning + mark, no slider. The
 * slider that used to live in the Hero now lives in its own Showcase
 * section directly below, so it still does the visual-hook job without
 * fighting the new hero for attention. Argument arc remains:
 * Hero → Showcase (real proof) → Problem → Work → Process → Proof →
 * AboutMe (face before the ask) → Finale.
 */
export default function App() {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <StructuredData />
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main id="main">
        <Hero />
        <Showcase />
        <Problem />
        <Transformation />
        <Process />
        <Proof />
        <AboutMe />
        <Finale />
      </main>
      <Footer />
    </>
  );
}
